import React, { Component } from 'react';
import SvgPanZoom from 'svg-pan-zoom';
import { Button } from 'reactstrap';
import PropTypes from 'prop-types';
import Hammer from 'hammerjs';
import { t } from 'ttag'
/**
 * Svg pan for react.
 *
 * @version 1.0.0
 * @author [Nagy Gergely](https://github.com/gergely-nagy)
 */
class SvgViewer extends Component {
  constructor(props) {
    super(props);

    this.main_group_selector = ".svg-pan-zoom_viewport";
    this.myRef = React.createRef();
    this.timeoutRef = React.createRef();
    this.state = {
      r: 10,
      first: true,
      inputValue: 0,
      disableClick: false,
      notDisabled: true,
    };

    this.eventsHandler;
    this.limitPan;

    this.limitPan = (oldPan, newPan) => {
      let stopHorizontal = false
        , stopVertical = false
        , gutterWidth = 150
        , gutterHeight = 150
        // Computed variables
        , sizes = this.panZoomTiger.getSizes()
        , leftLimit = -((sizes.viewBox.x + sizes.viewBox.width) * sizes.realZoom) + gutterWidth
        , rightLimit = sizes.width - gutterWidth - (sizes.viewBox.x * sizes.realZoom)
        , topLimit = -((sizes.viewBox.y + sizes.viewBox.height) * sizes.realZoom) + gutterHeight
        , bottomLimit = sizes.height - gutterHeight - (sizes.viewBox.y * sizes.realZoom)

      let customPan = {}
      customPan.x = Math.max(leftLimit, Math.min(rightLimit, newPan.x))
      customPan.y = Math.max(topLimit, Math.min(bottomLimit, newPan.y))

      return customPan
    }



    this.eventsHandler = {
      haltEventListeners: ['touchstart', 'touchend', 'touchmove', 'touchleave', 'touchcancel']
      , init: function (options) {
        var instance = options.instance
          , initialScale = 1
          , pannedX = 0
          , pannedY = 0

        // Init Hammer
        // Listen only for pointer and touch events
        this.hammer = Hammer(options.svgElement, {
          inputClass: Hammer.SUPPORT_POINTER_EVENTS ? Hammer.PointerEventInput : Hammer.TouchInput
        })

        // Enable pinch
        this.hammer.get('pinch').set({ enable: true })

        // Handle double

        // Handle pan
        this.hammer.on('panstart panmove', function (ev) {
          // On pan start reset panned variables
          if (ev.type === 'panstart') {
            pannedX = 0
            pannedY = 0
          }

          // Pan only the difference
          instance.panBy({ x: ev.deltaX - pannedX, y: ev.deltaY - pannedY })
          pannedX = ev.deltaX
          pannedY = ev.deltaY
        })

        // Handle pinch
        this.hammer.on('pinchstart pinchmove', function (ev) {
          // On pinch start remember initial zoom
          if (ev.type === 'pinchstart') {
            initialScale = instance.getZoom()
            instance.zoomAtPoint(initialScale * ev.scale, { x: ev.center.x - 50, y: ev.center.y - 200 })
          }

          instance.zoomAtPoint(initialScale * ev.scale, { x: ev.center.x - 50, y: ev.center.y - 200 })
        })

        // Prevent moving the page on some devices when panning over SVG
        options.svgElement.addEventListener('touchmove', function (e) { e.preventDefault(); });
      }

      , destroy: function () {
        this.hammer.destroy()
      }
    }

    if (!props.pinch) this.eventsHandler = null;
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.data !== prevProps.data) {
      this.panZoomTiger = SvgPanZoom(this.myRef.current, {
        zoomEnabled: this.props.zoomEnabled,
        dblClickZoomEnabled: false,
        controlIconsEnabled: false,
        fit: true,
        center: true,
        maxZoom: 2.5,
        beforePan: this.limitPan,
        zoomScaleSensitivity: 0.25,
        onPan: this.handlePanOrZoom,
        onZoom: this.handlePanOrZoom,
        customEventsHandler: this.eventsHandler,
      });
      if (this.state.first) {
        this.panZoomTiger.zoomOut();
        this.panZoomTiger.setMinZoom(this.panZoomTiger.getZoom());
      }
      this.setState({
        first: false,
      });
    }
  }

  componentDidMount() {
    const data = this.props.data;

    const hasContent =
      data &&
      (
        (Array.isArray(data.areas) && data.areas.length > 0) ||
        (Array.isArray(data.blocks) && data.blocks.length > 0) ||
        (Array.isArray(data.texts) && data.texts.length > 0)
      );

    if (this.props.fromAdmin && hasContent) {
      this.panZoomTiger = SvgPanZoom(this.myRef.current, {
        zoomEnabled: this.props.zoomEnabled,
        dblClickZoomEnabled: false,
        controlIconsEnabled: false,
        fit: true,
        center: true,
        maxZoom: 2.5,
        beforePan: this.limitPan,
        zoomScaleSensitivity: 0.25,
        onPan: this.handlePanOrZoom,
        onZoom: this.handlePanOrZoom,
        customEventsHandler: this.eventsHandler,
      });




      //if (!hasContent) return;


      if (this.props.twoColorMode) {
        this.setState({
          first: false,
        })
      }

      this.panZoomTiger.zoomOut();
      this.panZoomTiger.setMinZoom(this.panZoomTiger.getZoom());
    }
  }

  handlePanOrZoom = () => {
    clearTimeout(this.timeoutRef.current);
    this.setState({ disableClick: true });
    this.timeoutRef.current = setTimeout(() => this.setState({ disableClick: false }), 500);
  }

  isValuesEmpty = (x, y) => {
    let result = false;

    if (!x || !y) result = true;

    return result;
  }

  handleClick() {
    this.setState({
      disabled: true,
    });

    if (this.state.disabled) {
      return;
    }

    setTimeout(() => this.setState({ disabled: false }), 2000);
  }

  getCorrectTextColor = (hex) => {
    /*
    From this W3C document: http://www.webmasterworld.com/r.cgi?f=88&d=9769&url=http://www.w3.org/TR/AERT#color-contrast

    Color brightness is determined by the following formula:
    ((Red value X 299) + (Green value X 587) + (Blue value X 114)) / 1000

    I know this could be more compact, but I think this is easier to read/explain.

    */

    let threshold = 130; /* about half of 256. Lower threshold equals more dark text on dark background */

    function cutHex(h) { return (h.charAt(0) === '#') ? h.substring(1, 7) : h; }
    function hexToR(h) { return parseInt((cutHex(h)).substring(0, 2), 16); }
    function hexToG(h) { return parseInt((cutHex(h)).substring(2, 4), 16); }
    function hexToB(h) { return parseInt((cutHex(h)).substring(4, 6), 16); }

    let hRed = hexToR(hex);
    let hGreen = hexToG(hex);
    let hBlue = hexToB(hex);

    let cBrightness = ((hRed * 299) + (hGreen * 587) + (hBlue * 114)) / 1000;
    if (cBrightness > threshold) { return '#000000'; } return '#ffffff';
  }

  getColorBySzektorId = (id) => {
    let color = '3673bd';
    //let color = '008b02'; // ez akkor ha nem kötelező szektort emgadni mert akkro előnézeten is legyenek zöldek a székek
    // TODO: DELETE 3rd condition
    if (Array.isArray(this.props.szektorok) && this.props.szektorok.length > 0 && id) color = this.props.szektorok.find(x => x.id === id).col;
    return '#' + color;
  }

  getRingColorBySzektorId = (id, col) => {
    let color = '3673bd';
    // TODO: DELETE 3rd condition
    if (Array.isArray(this.props.szektorok) && this.props.szektorok.length > 0 && id) color = this.props.szektorok.find(x => x.id === id).col;
    if (!id && col) {
      color = col[0]
    }
    return '#' + color;
  }

  isSectorUseable = (id) => {
    let useable = false;
    if (id) {
      if (Array.isArray(this.props.szektorok) && this.props.szektorok.length > 0) {
        useable = this.props.szektorok.find(x => x.id === id).use;
      }
    }
    return useable;
  }

  renderSeats = (data, rowLabel, hasGroup, seatPrefix, seatSufix, blockPrefix) => {
    return data.map((e, idx) => (
      <g
        key={idx}
        className={e.col && (e.col[1] || !this.isSectorUseable(e.sec) || ('rid' in e)) ? "seats-no" : "seats"}
        onClick={() => {
          this.setState({
            notDisabled: true,
          });

          if (this.state.disableClick || !this.state.notDisabled) return;
          if (this.props.pinch) {
            this.setState({ notDisabled: false }, () => {
              setTimeout(() => this.setState({ notDisabled: true }), 300);
            });
          }
          if (!e.col || (!e.col[1] && this.isSectorUseable(e.sec)) || ('rid' in e)) {
            this.props.onSeatClick(e, hasGroup, rowLabel, seatPrefix, seatSufix, blockPrefix);
          }
        }}
        onTouchEnd={() => {
          this.setState({
            notDisabled: true,
          });
          if (this.state.disableClick || !this.state.notDisabled) return;
          if (this.props.pinch) {
            this.setState({ notDisabled: false }, () => {
              setTimeout(() => this.setState({ notDisabled: true }), 300);
            });
          }
          if (!e.col || (!e.col[1] && this.isSectorUseable(e.sec))) {
            this.props.onSeatClick(e, hasGroup, rowLabel, seatPrefix, seatSufix, blockPrefix);
          }
        }}
      >
        {this.props.withSectorColors && (
          <circle
            cx={e.x}
            cy={e.y}
            r={this.state.r + 3}
            fill={
              this.getRingColorBySzektorId(e.sec, e.col)
            }
          />
        )}
        <circle
          cx={e.x}
          cy={e.y}
          r={this.state.r}
          fill={
            this.props.aktivRendelesId && e.rid == this.props.aktivRendelesId ? 'yellow' : this.props.twoColorMode ?
              (e.col && e.col[1] ?
                (this.props.aktivRendelesSeatIds.includes(e.tid) ? '#ef8507' : '#6e6e6e') :
                (e.new ? '#ef8507' : this.getColorBySzektorId(e.sec))) :
              (e.res ?
                ('#' + this.props.szinek.cop) : e.new ? ('#' + this.props.szinek.con) : e.col ? '#' + e.col[0] :
                  this.getColorBySzektorId(e.sec))
          }
        />
        <text key={idx} x={e.x} y={e.y} fill={this.props.aktivRendelesId && e.rid == this.props.aktivRendelesId ? 'black' : this.props.twoColorMode ? this.getCorrectTextColor(this.getColorBySzektorId(e.sec)) : (e.col ? this.getCorrectTextColor(e.col[0]) : this.getCorrectTextColor(this.getColorBySzektorId(e.sec)))} fontSize={10} dominantBaseline="middle" textAnchor="middle">{e.lab}</text>
      </g>
    ));
  }

  renderBlocks = (data) => {
    let blocks = [];
    data && data.forEach((e, idx) => {
      if (e.seats && e.seats.length > 0) {
        let rot = e.rot || 0;
        if (e.seats.length > 1) {
            let p1 = e.seats[0];
            let p2 = e.seats[e.seats.length - 1];
            let dx = p2.x - p1.x;
            let dy = p2.y - p1.y;
            
            if (dx < 0 && Math.abs(dx) > 0.001) {
                dx = -dx;
                dy = -dy;
            } else if (Math.abs(dx) <= 0.001 && dy < 0) {
                dy = -dy;
            }
            rot = Math.atan2(dy, dx) * (180 / Math.PI);
        }

        let sumX = 0, sumY = 0;
        e.seats.forEach(s => { sumX += s.x; sumY += s.y; });
        const cx = sumX / e.seats.length;
        const cy = sumY / e.seats.length;

        const rad = (Math.PI / 180) * (-rot); 
        const cos = Math.cos(rad);
        const sin = Math.sin(rad);
        
        let minLocalX = Infinity;
        let maxLocalX = -Infinity;

        e.seats.forEach(s => {
          const dx = s.x - cx;
          const dy = s.y - cy;
          const localX = (dx * cos) - (dy * sin);
          
          if (localX < minLocalX) minLocalX = localX;
          if (localX > maxLocalX) maxLocalX = localX;
        });

        let lps = 'B'; 
        
        const rawLps = String(e.lps || '').toUpperCase();

        if (['B', 'J', 'M', 'N'].includes(rawLps)) {
            lps = rawLps;
        } else {
            if (Array.isArray(e.blp)) {
                const hasLeft = e.blp[0] !== null && e.blp[0] !== undefined;
                const hasRight = e.blp.length > 2 && e.blp[2] !== null && e.blp[2] !== undefined;
                
                if (hasLeft && hasRight) lps = 'M';
                else if (hasRight && !hasLeft) lps = 'J';
                else if (!hasRight && !hasLeft) lps = 'N';
                else lps = 'B';
            }
        }

        let textElements = [];
        if (lps === 'B' || lps === 'M') {
          textElements.push(
            <text key={`txt_l_${idx}`} x={cx + minLocalX - 30} y={cy + 1} fill="gray" fontSize="20" textAnchor="end" dominantBaseline="middle">
              <tspan>{e.lab}</tspan>
            </text>
          );
        }
        if (lps === 'J' || lps === 'M') {
          textElements.push(
            <text key={`txt_r_${idx}`} x={cx + maxLocalX + 30} y={cy + 1} fill="gray" fontSize="20" textAnchor="start" dominantBaseline="middle">
              <tspan>{e.lab}</tspan>
            </text>
          );
        }

        blocks.push(this.renderSeats(e.seats, e.lab, e.bsa, e.lsp, e.lss, e.lbp));

        if (textElements.length > 0) {
          blocks.push(
            <g key={`block_group_${idx}`} transform={`rotate(${rot} ${cx} ${cy})`}>
              {textElements}
            </g>
          );
        }
      }
    });

    return blocks;
  }

  renderAreas = (data) => {
    return data && data.map((e, idx) => {
      let sector = this.props.szektorok.find(x => x.id === e.sec && x.aid === e.tid);
      let capacityFree = (sector && sector.vcaf) ?? e.caf;
      return <g
        transform={'rotate(' + e.rot + ' ' + e.x + ' ' + e.y + ')'}
        cursor={(e.sec && e.cap > 0 && capacityFree > 0 && this.isSectorUseable(e.sec)) ? (this.props.isPublic ? 'default' : 'pointer') : 'not-allowed'}
        key={e.tid}
        onClick={() => {
          if (!this.props.isPublic && e.sec && e.cap > 0 && capacityFree > 0 && this.isSectorUseable(e.sec)) {
            this.props.onAreaClick(e);
          }
        }}
        onTouchEnd={() => {
          if (!this.props.isPublic && e.sec && e.cap > 0 && capacityFree > 0 && this.isSectorUseable(e.sec)) {
            this.props.onAreaClick(e);
          }
        }}
      >
        <rect
          x={e.x - (e.wid / 2)}
          y={e.y - (e.hei / 2)}
          fill={e.sec ? (capacityFree > 0 ? this.getColorBySzektorId(e.sec) : '#6e6e6e') : "#405471"}
          height={e.hei}
          width={e.wid}
          rx={e.rad}
          ry={e.rad}
          {...(e.new ? {
            strokeWidth: 3,
            stroke: this.getColor(this.props.aktivRendelesId, e.new, e.inorder, e.vanmeg, e.tid),
          } : {})}
        />
        <text key={idx} x={e.x} y={e.y} xmlSpace="preserve" fill="white" fontSize={e.las} dominantBaseline="middle" textAnchor="middle">{e.lab}</text>
      </g>
    });
  }

  getColor = (aktivRendelesId, isNew, isInOrder, isVanMeg, areaId) => {
    if (aktivRendelesId) {
      if (isNew) {
        if (isInOrder) {
          if (isVanMeg) {
            return this.props.aktivRendelesAreaIds.includes(areaId) ? 'yellow' : '#ef8507';
          } else {
            return this.props.aktivRendelesAreaIds.includes(areaId) ? '#ef8507' : 'yellow';
          }
        }
      }
    }
    return '#ef8507';
  }

  renderTexts = (data) => {
    if (data) return data.map((e, idx) => <text key={idx} x={e.x} y={e.y} xmlSpace="preserve" transform={'rotate(' + e.rot + ' ' + e.x + ' ' + e.y + ')'} fill={'#' + e.col} fontSize={e.las} dominantBaseline="middle" textAnchor="middle"><tspan>{e.lab}</tspan></text>);
    return null;
  }

  render() {
    const areas = this.renderAreas(this.props.data.areas);
    const blocks = this.renderBlocks(this.props.data.blocks);
    const texts = this.renderTexts(this.props.data.texts);

    const data = this.props.data;

    const hasContent =
      data &&
      (
        (Array.isArray(data.areas) && data.areas.length > 0) ||
        (Array.isArray(data.blocks) && data.blocks.length > 0) ||
        (Array.isArray(data.texts) && data.texts.length > 0)
      );
    return (
      <React.Fragment>
        <svg
          id={this.props.id}
          height={this.props.height}
          width="100%"
          onMouseDown={(event) => { event.preventDefault(); }}
          onMouseMove={(event) => { event.preventDefault(); }}
          ref={this.myRef}
        >
          <defs>
            <radialGradient id="myGradient">
              <stop offset="10%" stopColor="#3e87cd" />
              <stop offset="130%" stopColor="#3673bd" />
            </radialGradient>
            <linearGradient id="lgrad" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="20%" style={{ stopColor: '#192c43', stopOpacity: 0.9 }} />
              <stop offset="100%" style={{ stopColor: '#192c43', stopOpacity: 0 }} />
            </linearGradient>
          </defs>
          <g
            onKeyDown={this.props.onKeyDown}
            onKeyUp={this.props.onKeyUp}
            key="render"
          >
            {areas}
            {blocks}
            {texts}
          </g>
        </svg>
        <br></br>
        {this.props.isButtonsActive && hasContent && (
          <div style={{ marginTop: 20 }}>
            {' '}
            <Button
              onClick={() => {
                this.panZoomTiger.reset();
                this.panZoomTiger.zoomOut();
              }}
            >
              {t`Alapnézet`}
            </Button>
            {' '}
            <Button
              onClick={() => { this.panZoomTiger.zoomIn(); }}
            >
              {'+'}
            </Button>
            {' '}
            <Button
              onClick={() => { this.panZoomTiger.zoomOut(); }}
            >
              {'-'}
            </Button>
          </div>
        )
        }
      </React.Fragment>
    );
  }
}

SvgViewer.propTypes = {
  id: PropTypes.string,
  szinek: PropTypes.object,
  szektorok: PropTypes.array,
  height: PropTypes.string,
  data: PropTypes.object,
  onKeyDown: PropTypes.func,
  onKeyUp: PropTypes.func,
  onSeatClick: PropTypes.func,
  onAreaClick: PropTypes.func,
  zoomEnabled: PropTypes.bool,
  withSectorColors: PropTypes.bool,
  isButtonsActive: PropTypes.bool,
  twoColorMode: PropTypes.bool,
  pinch: PropTypes.bool,
  isPublic: PropTypes.bool,
  aktivRendelesId: PropTypes.number,
  aktivRendelesAreaIds: PropTypes.array,
  aktivRendelesSeatIds: PropTypes.array,
};

// Specifies the default values for props:
SvgViewer.defaultProps = {
  id: 'svg-viewer',
  height: '320px',
  zoomEnabled: true,
  withSectorColors: false,
  isButtonsActive: true,
  twoColorMode: false,
  pinch: false,
  aktivRendelesAreaIds: [],
  aktivRendelesSeatIds: [],
};

export default SvgViewer;
